module.exports = __webpack_public_path__ + "static/media/bottomChampions.31cf5d9a.png";